module.exports = __webpack_public_path__ + "static/sport/bgi-model.cc86d90.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/year/bgi-model.png
// module id = 8I8B
// module chunks = 0